import React from 'react';
import './style.css';
import logo from '../logo.png';


const Title = ()  => {
       return ( 
       <h1 className="appname"><img src={logo}  />Write the Classics</h1>
    );
}
export default Title;


// WEBPACK FOOTER //
// ./src/components/Title.js